import React from 'react';
import Hero from '../components/Hero';
import About from '../components/AboutSection';
import Services from '../components/ServicesSection';
import Gallery from '../components/GallerySection';

import Contact from '../components/ContactSection';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <About />
      <Services />
      <Gallery />
      {/* <Process /> */}
      <Contact />
    </div>
  );
};

export default Home;